<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="d-flex align-center">
      <v-checkbox
        v-model="isDiaSemanaCheckboxMarcado"
        class="ma-0 pa-0"
        hide-details
        style="max-width: 100px"
        :label="titulo"
        :disabled="!podeEditar"
        @click.stop=""
      />

      <div class="d-flex justify-end mr-2">
        <v-btn
          v-if="podeEditar"
          fab
          x-small
          :disabled="!isDiaSemanaCheckboxMarcado"
          :loading="isSalvarDisponibilidadeLoading"
          @click.stop="salvarDisponibilidade"
        >
          <v-icon>
            {{ icons.mdiContentSave }}
          </v-icon>
        </v-btn>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <agenda-disponibilidade-dia-conteudo
        titulo="Manhã"
        :readonly="!isDiaSemanaCheckboxMarcado || !podeEditar"
        :horario-inicial-iso.sync="horarioManha.inicial"
        :horario-final-iso.sync="horarioManha.final"
        :horario-minimo-iso="horarioManha.minimo"
        :horario-maximo-iso="horarioManha.maximo"
        @update:horario-checkbox="v => isHorarioManhaCheckboxMarcado = v"
      />

      <agenda-disponibilidade-dia-conteudo
        titulo="Tarde"
        :readonly="!isDiaSemanaCheckboxMarcado || !podeEditar"
        :horario-inicial-iso.sync="horarioTarde.inicial"
        :horario-final-iso.sync="horarioTarde.final"
        :horario-minimo-iso="horarioTarde.minimo"
        :horario-maximo-iso="horarioTarde.maximo"
        @update:horario-checkbox="v => isHorarioTardeCheckboxMarcado = v"
      />

      <agenda-disponibilidade-dia-conteudo
        titulo="Noite"
        :readonly="!isDiaSemanaCheckboxMarcado || !podeEditar"
        :horario-inicial-iso.sync="horarioNoite.inicial"
        :horario-final-iso.sync="horarioNoite.final"
        :horario-inicial-allowed-hours="horarioNoite.inicialAllowedHours"
        :horario-final-allowed-hours="horarioNoite.finalAllowedHours"
        @update:horario-checkbox="v => isHorarioNoiteCheckboxMarcado = v"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
// import { storeToRefs } from 'pinia' // REMOVIDO
import { mdiContentSave } from '@mdi/js'
import AgendaDisponibilidadeDiaConteudo from './AgendaDisponibilidadeDiaSemanaConteudo.vue'
import PeriodoDisponibilidadeEnum from '@/models/entities/agente/PeriodoDisponibilidadeEnum'
import AgenteService from '@/services/modules/AgenteService'
// import useUserStore from '@/store/user' // REMOVIDO

export default {
  components: {
    AgendaDisponibilidadeDiaConteudo,
  },

  props: {
    diaSemanaId: {
      type: Number,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    disponibilidadesDoDia: {
      type: Array,
      required: true,
    },
    // NOVAS PROPS
    agenteId: {
      type: Number,
      required: true,
    },
    podeEditar: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    // REMOVIDO: const { id: agenteId } = storeToRefs(useUserStore())

    const isDiaSemanaCheckboxMarcado = ref(false)
    const isSalvarDisponibilidadeLoading = ref(false)

    const horarioManha = ref({ id: null, inicial: null, final: null, minimo: '05:00', maximo: '11:59' })
    const horarioTarde = ref({ id: null, inicial: null, final: null, minimo: '12:00', maximo: '17:59' })
    const horarioNoite = ref({
      id: null,
      inicial: null,
      final: null,
      minimo: '18:00',
      maximo: '04:59',
      inicialAllowedHours: v => (v > 18 && v <= 23),
      finalAllowedHours: v => (v > 18 && v <= 23) || (v > 0 && v < 5),
    })

    const isHorarioManhaNovo = computed(() => !horarioManha.value.id)
    const isHorarioTardeNovo = computed(() => !horarioTarde.value.id)
    const isHorarioNoiteNovo = computed(() => !horarioNoite.value.id)

    const isHorarioManhaCheckboxMarcado = ref(false)
    const isHorarioTardeCheckboxMarcado = ref(false)
    const isHorarioNoiteCheckboxMarcado = ref(false)

    function resetHorarios() {
      isDiaSemanaCheckboxMarcado.value = false

      horarioManha.value.id = null
      horarioManha.value.inicial = null
      horarioManha.value.final = null
      isHorarioManhaCheckboxMarcado.value = false

      horarioTarde.value.id = null
      horarioTarde.value.inicial = null
      horarioTarde.value.final = null
      isHorarioTardeCheckboxMarcado.value = false

      horarioNoite.value.id = null
      horarioNoite.value.inicial = null
      horarioNoite.value.final = null
      isHorarioNoiteCheckboxMarcado.value = false
    }

    watch(
      () => props.disponibilidadesDoDia,
      v => {
        if (!v.length) {
          isDiaSemanaCheckboxMarcado.value = false
          resetHorarios()
          return
        }

        isDiaSemanaCheckboxMarcado.value = true

        const manha = v.find(it => it.periodoDiaDisponibilidadeId === PeriodoDisponibilidadeEnum.Manha)
        const tarde = v.find(it => it.periodoDiaDisponibilidadeId === PeriodoDisponibilidadeEnum.Tarde)
        const noite = v.find(it => it.periodoDiaDisponibilidadeId === PeriodoDisponibilidadeEnum.Noite)

        horarioManha.value.id = manha?.id || null
        horarioManha.value.inicial = manha?.inicial || null
        horarioManha.value.final = manha?.final || null
        isHorarioManhaCheckboxMarcado.value = !!horarioManha.value.inicial && !!horarioManha.value.final

        horarioTarde.value.id = tarde?.id || null
        horarioTarde.value.inicial = tarde?.inicial || null
        horarioTarde.value.final = tarde?.final || null
        isHorarioTardeCheckboxMarcado.value = !!horarioTarde.value.inicial && !!horarioTarde.value.final

        horarioNoite.value.id = noite?.id || null
        horarioNoite.value.inicial = noite?.inicial || null
        horarioNoite.value.final = noite?.final || null
        isHorarioNoiteCheckboxMarcado.value = !!horarioNoite.value.inicial && !!horarioNoite.value.final
      },
      {
        immediate: true,
        deep: true,
      },
    )

    async function salvarHorarioManha() {
      if (!isHorarioManhaCheckboxMarcado.value && !isHorarioManhaNovo.value) {
        // CORREÇÃO: props.agenteId
        return AgenteService.excluirDisponibilidadeAgente(props.agenteId, horarioManha.value.id)
      }

      if (isHorarioManhaCheckboxMarcado.value) {
        if (isHorarioManhaNovo.value) {
          return AgenteService.criarDisponibilidadeAgente(props.agenteId, {
            diaSemana: props.diaSemanaId,
            horaInicial: `${horarioManha.value.inicial}:00`,
            horaFinal: `${horarioManha.value.final}:00`,
          })
        }

        return AgenteService.atualizarDisponibilidadeAgente(props.agenteId, horarioManha.value.id, {
          diaSemana: props.diaSemanaId,
          horaInicial: `${horarioManha.value.inicial}:00`,
          horaFinal: `${horarioManha.value.final}:00`,
        })
      }
    }

    async function salvarHorarioTarde() {
      if (!isHorarioTardeCheckboxMarcado.value && !isHorarioTardeNovo.value) {
        return AgenteService.excluirDisponibilidadeAgente(props.agenteId, horarioTarde.value.id)
      }

      if (isHorarioTardeCheckboxMarcado.value) {
        if (isHorarioTardeNovo.value) {
          return AgenteService.criarDisponibilidadeAgente(props.agenteId, {
            diaSemana: props.diaSemanaId,
            horaInicial: `${horarioTarde.value.inicial}:00`,
            horaFinal: `${horarioTarde.value.final}:00`,
          })
        }

        return AgenteService.atualizarDisponibilidadeAgente(props.agenteId, horarioTarde.value.id, {
          diaSemana: props.diaSemanaId,
          horaInicial: `${horarioTarde.value.inicial}:00`,
          horaFinal: `${horarioTarde.value.final}:00`,
        })
      }
    }

    async function salvarHorarioNoite() {
      if (!isHorarioNoiteCheckboxMarcado.value && !isHorarioNoiteNovo.value) {
        return AgenteService.excluirDisponibilidadeAgente(props.agenteId, horarioNoite.value.id)
      }

      if (isHorarioNoiteCheckboxMarcado.value) {
        if (isHorarioNoiteNovo.value) {
          return AgenteService.criarDisponibilidadeAgente(props.agenteId, {
            diaSemana: props.diaSemanaId,
            horaInicial: `${horarioNoite.value.inicial}:00`,
            horaFinal: `${horarioNoite.value.final}:00`,
          })
        }

        return AgenteService.atualizarDisponibilidadeAgente(props.agenteId, horarioNoite.value.id, {
          diaSemana: props.diaSemanaId,
          horaInicial: `${horarioNoite.value.inicial}:00`,
          horaFinal: `${horarioNoite.value.final}:00`,
        })
      }
    }

    async function salvarDisponibilidade() {
      if (isSalvarDisponibilidadeLoading.value) return
      if (!props.podeEditar) return // Segurança extra

      try {
        isSalvarDisponibilidadeLoading.value = true

        await salvarHorarioManha()
        await salvarHorarioTarde()
        await salvarHorarioNoite()

        emit('refetch-data')
      } finally {
        isSalvarDisponibilidadeLoading.value = false
      }
    }

    return {
      isDiaSemanaCheckboxMarcado,
      isSalvarDisponibilidadeLoading,
      horarioManha,
      horarioTarde,
      horarioNoite,
      isHorarioManhaCheckboxMarcado,
      isHorarioTardeCheckboxMarcado,
      isHorarioNoiteCheckboxMarcado,
      salvarDisponibilidade,
      icons: {
        mdiContentSave,
      },
    }
  },
}
</script>
